/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import React from "react";
import Head from "next/head";
import Header from "../../common/header/Header";
import Footer from "../../common/footer/Footer";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      a: "a",
      h2: "h2",
      strong: "strong",
      ul: "ul",
      li: "li"
    }, props.components);
    return _jsxs("main", {
      className: "page-wrapper",
      children: [_jsx(Head, {
        children: _jsx("title", {
          children: "Modulabs | Cancellation policy"
        })
      }), _jsx(Header, {
        className: "header-not-transparent"
      }), _jsx("div", {
        className: "post-page-banner rn-section-gapTop",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content text-center",
                children: _jsx("div", {
                  className: "page-title",
                  children: _jsx("h1", {
                    className: "theme-gradient",
                    children: "Cancellation policy"
                  })
                })
              })
            })
          })
        })
      }), _jsx("div", {
        className: "blog-details-content pt--60 rn-section-gapBottom",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content",
                children: _jsxs("div", {
                  children: [_jsx(_components.p, {
                    children: "We want satisfied customers, not hostages. That’s why we make it easy for you to cancel your\naccount directly in all of our apps — no phone calls required, no questions asked."
                  }), _jsx(_components.p, {
                    children: "Account owners can follow these instructions to cancel in-app."
                  }), _jsxs(_components.p, {
                    children: ["Our legal responsibility is to account owners, which means we cannot cancel an account at\nthe request of anyone else. If for whatever reason you no longer know who the account owner\nis, ", _jsx(_components.a, {
                      href: "mailto:support@modulabs.io",
                      children: "contact us"
                    }), ". We will gladly reach out to any current account\nowners at the email addresses we have on file."]
                  }), _jsx(_components.h2, {
                    children: "What happens when you cancel?"
                  }), _jsxs(_components.p, {
                    children: ["We’ll permanently delete your account data 30 days after cancellation from our servers and\nlogs, and within 60 days from our backups. Retrieving data for a single account from a\nbackup isn’t possible, so if you change your mind you’ll need to do it within the first 30\ndays after cancellation. ", _jsx(_components.strong, {
                      children: "Data can’t be recovered once it has been permanently deleted."
                    })]
                  }), _jsxs(_components.p, {
                    children: ["We won’t bill you again once you cancel. We don’t automatically prorate any unused time you\nmay have left but if you haven’t used your account in months or just started a new billing\ncycle, ", _jsx(_components.a, {
                      href: "mailto:support@modulabs.io",
                      children: "contact us"
                    }), " for a ", _jsx(_components.a, {
                      href: "./refund",
                      children: "fair refund"
                    }), ". We’ll\ntreat you right."]
                  }), _jsx(_components.h2, {
                    children: "Modulabs-initiated cancellations"
                  }), _jsx(_components.p, {
                    children: "We may cancel accounts if they have been inactive for an extended period:"
                  }), _jsxs(_components.ul, {
                    children: ["\n", _jsxs(_components.li, {
                      children: ["For trial accounts:", "\n", _jsxs(_components.ul, {
                        children: ["\n", _jsx(_components.li, {
                          children: "30 days after a trial has expired without being upgraded"
                        }), "\n", _jsx(_components.li, {
                          children: "For frozen accounts: 180 days after being frozen due to billing failures"
                        }), "\n", _jsx(_components.li, {
                          children: "For free accounts: after 365 days of inactivity"
                        }), "\n"]
                      }), "\n"]
                    }), "\n"]
                  }), _jsxs(_components.p, {
                    children: ["We also retain the right to suspend or terminate accounts for any reason at any time, as\noutlined in our ", _jsx(_components.a, {
                      href: "./terms",
                      children: "Terms of Service"
                    }), ". In practice, this generally means we\nwill cancel your account without notice if we have evidence that you are using our products\nto engage in ", _jsx(_components.a, {
                      href: "./abuse",
                      children: "abusive behavior"
                    }), "."]
                  }), _jsxs(_components.p, {
                    children: ["Adapted from the ", _jsx(_components.a, {
                      href: "https://github.com/basecamp/policies",
                      children: "Basecamp open-source policies"
                    }), " / ", _jsx(_components.a, {
                      href: "https://creativecommons.org/licenses/by/4.0/",
                      children: "CC\nBY 4.0"
                    })]
                  })]
                })
              })
            })
          })
        })
      }), _jsx(Footer, {})]
    });
  }
}
export default MDXContent;
